export class BookingUtility {

    static rdv_price(prestations, group_size) {
        let sum = 0;
        
        for (const presta of prestations) {
            sum += presta.price;
        }
        console.log('BookingUtility price',sum,group_size);
        return sum*group_size;
    }

    static get_attendees_from_rdv(rdv, client_id) {
        if (!rdv || !Array.isArray(rdv.participants)) {
            return [];
        }
    
        // Find the participant with the matching client_id
        const participant = rdv.participants.find(
            p => p.client_id === client_id
        );
    
        if (!participant || !participant.attendees) {
            return [];
        }
    
        // attendees is stored as a JSON string → parse it
        try {
            return JSON.parse(participant.attendees);
        } catch (e) {
            console.error("Invalid attendee JSON:", participant.attendees);
            return [];
        }
    }
    
}